// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var EmbedVersion;
(function (EmbedVersion) {
    EmbedVersion["Iframe"] = "iframe";
    EmbedVersion["Twitter"] = "twitter";
    EmbedVersion["YouTube"] = "youtube";
    EmbedVersion["PDF"] = "pdf";
    EmbedVersion["Video"] = "video";
    EmbedVersion["VideoSwitch"] = "video_switch";
})(EmbedVersion || (EmbedVersion = {}));
